<script>
	import SignInForm from './SignInForm.svelte';
	import { serviceContext } from './ServiceContext';
	import { onMount, tick } from 'svelte';
	import * as DropdownMenu from './shadcn/components/ui/dropdown-menu';
	import { Button } from './shadcn/components/ui/button';
	import { goto } from '$app/navigation';
	import Avatar from './components/Avatar.svelte';
	import { Skeleton } from './shadcn/components/ui/skeleton';
	import { cn } from './shadcn/utils';
	import * as Dialog from './shadcn/components/ui/dialog';
	import { SignInState } from './AuthService.svelte';
	import { resolveLocale } from './utils.svelte';

	let signInInProgress = $state(false);
	let hydrated = $state(false);

	let { showNav = false, showPricing = false, blurIn = false } = $props();

	onMount(async () => {
		await serviceContext.authService.authReady();
		hydrated = true;
	});
</script>

<nav
	class={cn(
		'sticky top-0 z-40 flex h-16 items-center justify-between px-4 backdrop-blur-xs md:px-12',
		{ '**:blurIn': blurIn }
	)}
>
	<a
		href={resolveLocale('/(webapp)/[[locale=locale]]')}
		class="text-primary text-xl font-semibold delay-1050 lg:text-2xl">TightStacks</a
	>
	<div class="flex items-center gap-8 delay-1200">
		{#if showNav}
			<div class="hidden gap-8 sm:flex">
				<a href="#examples" class="hover:underline">Examples</a>
				<a href="#usage" class="hover:underline">Usage</a>
				{#if showPricing}
					<a href="#pricing" class="hover:underline">Pricing</a>
				{/if}
				<a href="#faq" class="hover:underline">FAQ</a>
			</div>
		{/if}
		{#if hydrated}
			{#if serviceContext.authService.getSignInState() == SignInState.SignedIn && !signInInProgress}
				<DropdownMenu.Root>
					<DropdownMenu.Trigger class="size-10">
						<Avatar class="size-10" name={serviceContext.userService.getUsername() ?? ''} />
					</DropdownMenu.Trigger>

					<DropdownMenu.Content class="w-60" align="end">
						<DropdownMenu.Group class="flex flex-col gap-1">
							<DropdownMenu.Item
								variant="filled"
								onSelect={() => goto(resolveLocale('/(webapp)/[[locale=locale]]/account'))}
								>Account</DropdownMenu.Item
							>
							<DropdownMenu.Item
								onSelect={serviceContext.authService.signOut}
								variant="destructive"
							>
								Sign out
							</DropdownMenu.Item>
						</DropdownMenu.Group>
					</DropdownMenu.Content>
				</DropdownMenu.Root>
			{:else}
				<Dialog.Root>
					<Dialog.Trigger
						><Button variant="outline" class="rounded-full px-5">Sign in</Button></Dialog.Trigger
					>
					<Dialog.Portal>
						<Dialog.Overlay inert>
							<div class="fixed top-0 left-0 h-full w-full bg-black opacity-30"></div>
						</Dialog.Overlay>
						<Dialog.Content
							escapeKeydownBehavior={signInInProgress ? 'ignore' : 'close'}
							interactOutsideBehavior={signInInProgress ? 'ignore' : 'close'}
							class="xs:max-w-[calc(100%-2rem)] xs:w-auto fixed top-[50%] left-[50%] z-50 flex w-full translate-x-[-50%] translate-y-[-50%] p-0"
						>
							<SignInForm
								onBegin={async () => {
									signInInProgress = true;
									await tick();
								}}
								onSuccess={async () => {
									signInInProgress = false;
								}}
								onFailure={async () => {
									signInInProgress = false;
								}}
							/>
						</Dialog.Content>
					</Dialog.Portal>
				</Dialog.Root>
			{/if}
		{:else}
			<Skeleton class="-animate-pulse size-10 rounded-full" />
		{/if}
	</div>
</nav>
